import React, { useState, useEffect, useRef } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete, MdPerson } from "react-icons/md";
import ToastFile from "../../utils/ToastFile";
import {
  deleteContractorByID,
  getAllContractor,
} from "../../api/ContractorApi";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getAllTenants } from "../../api/TenantApi";
import DeleteModel from "../../components/DeleteModel";

const Contractor = () => {
  const [tenants, setTenants] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [isPasswordVisible, setIsPasswordVisible] = useState({});
  const navigate = useNavigate();
  const fetched = useRef(false);
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState(0);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getContractor();
    getTenants();
  }, []);

  const togglePasswordVisibility = (id) => {
    setIsPasswordVisible((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getContractor = () => {
    getAllContractor()
      .then((res) => {
        if (res.status === 200) {
          setContractors(res?.data?.data?.contractors);
        } else {
          ToastFile("Failed to fetch contractors", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching contractors:", err);
        ToastFile("Error fetching contractors", "error");
      });
  };

  const getTenants = () => {
    getAllTenants()
      .then((res) => {
        if (res.status === 200) {
          setTenants(res?.data?.data?.tenants);
        } else {
          ToastFile("Failed to fetch tenants", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tenants:", err);
        ToastFile("Error fetching tenants", "error");
      });
  };

  const openAddModal = () => {
    navigate("/contractors/add");
  };

  const openEditModal = (index) => {
    const contractor = contractors[index];
    navigate("/contractors/edit", {
      replace: true,
      state: { contractor },
    });
  };

  const openProfile = () => {
    navigate("/contractors/profile");
  };

  const deleteContractor = () => {
    deleteContractorByID(contractors[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Contractor deleted", "deleted");
          fetched.current = false;
          getContractor();
        } else {
          ToastFile("Failed to delete contractor", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting contractor:", err);
        ToastFile("Error deleting contractor", "error");
      })
      .finally(()=>{
        setDeleteIndex(0)
        setDeleteModal(false)
      })
  };

  return (
    <Layout>
      <DeleteModel showModal={deleteModal} setShowModal={setDeleteModal} onYes={deleteContractor}/>
      <div className="d-flex justify-content-between align-items-center mb-3">
         <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            Contractor Management
          </span>
        <div>
          <Button onClick={openAddModal} className="bg-dark">
            + Add Contractor
          </Button>
        </div>
      </div>
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr style={{ textAlign:'center' }}>
            <th>Name</th>
            <th>Email</th>
            <th>Password</th>
            <th>Address</th>
            <th>Contact No</th>
            <th>Company</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {contractors.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center">
                No contractors found
              </td>
            </tr>
          ) : (
            contractors?.map((c, idx) => (
              <tr key={idx}>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td className="d-flex justify-content-between align-items-center">
                  {isPasswordVisible[idx]
                    ? c.password
                    : "*".repeat(c.password.length)}
                  <button
                    className="border-0"
                    onClick={() => togglePasswordVisibility(idx)}
                  >
                    {isPasswordVisible[idx] ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </td>
                <td>{c.address}</td>
                <td>{c.contact_no}</td>
                <td>{tenants.find((el) => el._id === c.tenant_id)?.name}</td>
                <td style={{ textAlign: 'center' }}>
                  {c.status === "Active" ? (
                    <span className="badge bg-success">{c.status}</span>
                  ) : (
                    <span className="badge bg-danger">{c.status}</span>
                  )}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <span
                    className="me-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => openEditModal(idx)}
                  >
                    <MdModeEdit size={20} />
                  </span>

                  <span
                    className="me-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                  >
                    <MdDelete size={20} />
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Layout>
  );
};

export default Contractor;
